import { refs, domReady, booleanDataset } from '../modules/utils.js';
import Swiper from 'swiper';
import { test as testMedia } from '../modules/match-media.js';

class SocialProof extends HTMLElement {
  static get observedAttributes() {
    return [];
  }

  attributeChangedCallback(name, oldValue, newValue) { }

  async connectedCallback() {
    await domReady();
    this.refs = refs(this);
    this.#listeners();
    this.#slider();
  }

  #listeners() {
    this.refs.next?.addEventListener('click', (e) => {
      if (this.slider) {
        this.slider.slideNext();
      }
    });

    this.refs.prev?.addEventListener('click', (e) => {
      if (this.slider) {
        this.slider.slidePrev();
      }
    });

    // video
    let currentMobileCardEl = null;
    this.refs.cards?.forEach((card) => {
      const video = card.querySelector('video');
      const audioIcon = card.querySelector('[data-audio]');
      card.addEventListener('mouseenter', () => {
        if (video) {
          video.play();
        }
      });
      card.addEventListener('mouseleave', () => {
        if (video) {
          video.pause();
          video.currentTime = 0;
          video.muted = true;
          if (audioIcon) {
            booleanDataset(audioIcon, 'active', false);
          }
        }
      });

      if (video && testMedia('small')) {
        card.addEventListener('click', (e) => {
          if (e.target.classList.contains('socialproof-card-image')) {
            e.preventDefault();

            if (currentMobileCardEl) {
              const prevVideo = currentMobileCardEl.querySelector('video');
              if (prevVideo) {
                prevVideo.pause();
                prevVideo.currentTime = 0;
                prevVideo.style.opacity = 0;
              }
            }

            currentMobileCardEl = card;
            video.style.opacity = 1;
            video.play();
          }
        });
      }
    });

    // audio
    this.refs.cards?.forEach((card) => {
      const audioIcon = card.querySelector('[data-audio]');
      const video = card.querySelector('video');
      audioIcon?.addEventListener('click', (e) => {
        e.preventDefault();
        if (video) {
          video.muted = !video.muted;
          booleanDataset(audioIcon, 'active', !video.muted);
        }
      });
    });
  }

  #slider() {
    if (!this.refs.slider) return;

    let slidesPerView = 3.5;
    if (testMedia('small')) {
      slidesPerView = 1.1;
    }

    this.slider = new Swiper(
      this.refs.slider,
      {
        slidesPerView,
        spaceBetween: 0,
        loop: true,
        loopAdditionalSlides: 1
      }
    );

    this.slider.on('slideChange', () => {
      this.dataset.index = this.slider.realIndex;
    });
  }
}

customElements.define('social-proof', SocialProof);
